import React from 'react';
import { useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';

// Standalone event landing pages ship their own compact hero and don't use
// the main site header — pt-28 exists purely to offset the fixed header, so
// it's dropped too when the header isn't rendered.
const HIDE_HEADER_PREFIXES = ['/events/'];

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const hideHeader = HIDE_HEADER_PREFIXES.some((prefix) => pathname.startsWith(prefix));

  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen">
        {!hideHeader && <Header />}
        <main className={`flex-grow ${hideHeader ? '' : 'pt-28'}`}>
          {children}
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Layout;